import React from "react";
import { Link } from "react-router-dom";

const Features = () => {
  const features = [
    {
      title: "Find Your Perfect Appliance",
      description:
        "We offer electric chimneys, gas stoves, and hobs to suit your cooking needs. Our products are designed to remove smoke and built to perform 360 degree stereo inflow structure design to help effectively capturing and eliminating cooking odours.",
      image: "img/home/trendy.webp",
      link: "/products",
      buttonText: "View Products",
      icon: (
        <svg
          className="w-8 h-8 text-indigo-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
      ),
    },
    {
      title: "Effortless Appliance Installation",
      description:
        "Get your new appliances up and running with ease. Our team of expert technicians will handle the installation process, ensuring that your appliances are set up correctly and that you're completely satisfied with your purchase.",
      image: "img/home/chimney_3.webp",
      link: "/contact-us",
      buttonText: "Inquiry Now",
      icon: (
        <svg
          className="w-8 h-8 text-indigo-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      ),
    },
    {
      title: "We're Here to Help",
      description:
        "Need help with your appliances? Our knowledgeable and friendly customer support team is here to assist you every step of the way. Contact us for answers to your questions, troubleshooting help, and more.",
      image: "img/home/curvee.webp",
      link: "/contact-us",
      buttonText: "Contact Us",
      icon: (
        <svg
          className="w-8 h-8 text-indigo-600"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M12 2.25a9.75 9.75 0 100 19.5 9.75 9.75 0 000-19.5z"
          />
        </svg>
      ),
    },
  ];

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <h2 className="text-3xl md:text-4xl font-bold text-indigo-600 mb-4">
          Why Choose Alpha Appliances?
        </h2>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto">
          We provide comprehensive kitchen solutions with premium products,
          professional installation, and exceptional customer support.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {features.map((feature, index) => (
          <div
            key={index}
            className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 transform hover:scale-105"
          >
            <div className="relative">
              <img
                src={feature.image}
                alt={feature.title}
                className="w-full h-48 object-cover"
              />
              <div className="absolute top-4 right-4 bg-white rounded-full p-2 shadow-lg">
                {feature.icon}
              </div>
            </div>
            <div className="p-6">
              <h3 className="text-xl font-bold text-indigo-600 mb-4">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed mb-6">
                {feature.description}
              </p>
              <Link
                to={feature.link}
                className="inline-flex items-center justify-center w-full px-6 py-3 bg-indigo-600 hover:bg-indigo-700 text-white font-semibold rounded-lg transition-colors duration-300"
              >
                {feature.buttonText}
              </Link>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Features;
